import { Checkbox, TableCell, TableHead, TableRow } from '@mui/material';
import { headCells } from './Functions';

const CENTER_CELL = ['id', 'action', 'actions']

/**
 * Component table header
 * -----
 * Cập nhật [240801] - Thêm lọc danh sách bản ghi theo điều kiện
 * @param {*} onSelectAllClick: Hàm xử lý click checkbox
 * @param {*} numSelected: Số lượng bản ghi được chọn
 * @param {*} rows: Danh sách bản ghi có trong bảng hiện tại
 * @param {*} headCellTable: Dữ liệu tên trường trong bảng
 * @param     dataSelected: Danh sách bản ghi trong bảng hiện tại
 * @param     selected: Danh sách bản ghi đã được chọn
 * @param     rowId: Tên trường được chọn làm id của bản ghi
 * @returns
 */
const TableHeaderCC = ({ onSelectAllClick, rows, headCellTable = headCells, selected, rowId }) => {
    const currentSelectedPage = onSelectAllClick && rows?.filter((r) => selected.includes(r[rowId])).length;

    return (
        <TableHead>
            <TableRow>
                {onSelectAllClick && (
                    <TableCell padding="checkbox">
                        <Checkbox
                            data-tour="select_all"
                            indeterminate={!!(currentSelectedPage > 0 && currentSelectedPage < rows?.length)}
                            checked={!!(currentSelectedPage > 0 && currentSelectedPage === rows?.length)}
                            onChange={onSelectAllClick}
                            inputProps={{
                                'aria-label': 'select all desserts',
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    const el = {
                                        target: {
                                            checked: !e?.target?.checked,
                                        },
                                    };
                                    onSelectAllClick(el);
                                }
                            }}
                        />
                    </TableCell>
                )}
                {headCellTable.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={CENTER_CELL.includes(headCell.id) ? 'center' : headCell.numeric ? 'right' : 'left'}
                        padding={headCell.id === 'id' ? 'checkbox' : headCell.disablePadding ? 'none' : 'normal'}
                        sx={{ whiteSpace: 'nowrap', color: (theme) => theme.palette.text[700] }}
                    >
                        {headCell.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default TableHeaderCC;
